"use client";

import { useCallback } from "react";
import { useCommandBar } from "@/components/command-bar/command-bar-context";
import type { CommandGroup } from "@/components/command-bar/command-bar-context";

export interface ContextConfig {
  badge?: string;
  label?: string;
  groups: CommandGroup[];
}

export function useCommandBarShortcuts() {
  const { setContextConfig, clearContext, openCommandBar, isOpen } =
    useCommandBar();

  const setRowContext = useCallback(
    (config: ContextConfig) => {
      setContextConfig(config);
    },
    [setContextConfig],
  );

  const clearRowContext = useCallback(() => {
    clearContext();
  }, [clearContext]);

  const openWithContext = useCallback(
    (config: ContextConfig) => {
      setContextConfig(config);
      openCommandBar();
    },
    [setContextConfig, openCommandBar],
  );

  return {
    setRowContext,
    clearRowContext,
    openWithContext,
    isOpen,
  };
}
